import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "@/data/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("talibnaz_lang") || "en";
  });

  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute("lang", lang);
    html.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
    document.body.setAttribute("data-lang", lang);
    localStorage.setItem("talibnaz_lang", lang);
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggle: () => setLang((prev) => (prev === "en" ? "ar" : "en")),
      t: (key) => {
        const parts = key.split(".");
        let node = translations[lang];
        for (const p of parts) {
          if (node == null) return key;
          node = node[p];
        }
        return node ?? key;
      },
      isRTL: lang === "ar",
    }),
    [lang]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
